// extracted by mini-css-extract-plugin
export var closeButton = "_cp-1";
export var closeX = "_cp-3";
export var container = "_cp-0";
export var image = "_cp-2";